import { render } from "./CreditRequest.vue?vue&type=template&id=6f98cf83"
import script from "./CreditRequest.vue?vue&type=script&lang=js"
export * from "./CreditRequest.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__